export default __webpack_public_path__ + "static/14-b32d8417956a79342295032302499f5b.webp";